import { z } from 'zod';
import { UpsertChallengeRequestBody } from '@/src/apis/rest/challenge.dtos';
import { DateRange } from 'react-day-picker';
import { Media } from '@/src/models/MeidaDto';
import {
  defaultCautions,
  defaultInfos,
} from '@/src/pages/Challenge/defaultData';

export type FormValues = UpsertChallengeRequestBody & {
  startedDateRange: DateRange;
  thumbnailImage?: Media;
  approveExampleImage?: Media;
  rejectExampleImage?: Media;
};

export const DEFAULT_VALUES: Partial<FormValues> = {
  startedAt: '',
  endedAt: '',
  startedDateRange: {
    from: undefined,
    to: undefined,
  },
  title: '',
  content: '',
  isExposed: true,
  priorityDisplayYn: true,
  creditTemplateId: undefined,
  generateChallengeInfos: defaultInfos as {
    id: number;
    contents: string;
  }[],
  generateChallengeCautions: defaultCautions as {
    id: number;
    contents: string;
  }[],
};

export const formSchema = () => {
  return z.object({
    startedAt: z.string(),
    endedAt: z.string(),
    title: z.string().min(1),
    content: z.string().min(1),
    creditTemplateId: z.number().nullable(),
    thumbnailImageId: z.number(),
    approveExampleImageId: z.number(),
    rejectExampleImageId: z.number(),
    generateChallengeInfos: z.array(
      z.object({ id: z.number().optional(), contents: z.string().min(1) }),
    ),
    generateChallengeCautions: z.array(
      z.object({ id: z.number().optional(), contents: z.string().min(1) }),
    ),
    isExposed: z.boolean(),
    priorityDisplayYn: z.boolean(),
    removeInfoIds: z.array(z.number()).optional(),
    removeCautionIds: z.array(z.number()).optional(),
  });
};

export const formFields = {
  startedDateRange: {
    name: 'startedDateRange',
  },
  isExposed: {
    name: 'isExposed',
  },
  priorityDisplayYn: {
    name: 'priorityDisplayYn',
  },
  creditTemplateId: {
    name: 'creditTemplateId',
  },
  thumbnailImageId: {
    name: 'thumbnailImageId',
  },
  approveExampleImageId: {
    name: 'approveExampleImageId',
  },
  rejectExampleImageId: {
    name: 'rejectExampleImageId',
  },
  title: {
    name: 'title',
  },
  content: {
    name: 'content',
  },
  generateChallengeInfos: {
    name: 'generateChallengeInfos',
  },
  generateChallengeCautions: {
    name: 'generateChallengeCautions',
  },
  participantsCnt: {
    name: 'participantsCnt',
  },
  createdAt: {
    name: 'createdAt',
  },
  administrator: {
    name: 'administrator',
  },
} as const;
